<template>
  <v-progress-circular
    color="primary"
    :size="size"
    indeterminate
  />
</template>

<script lang='ts'>
import { Vue, Component, Prop } from 'vue-facing-decorator'

@Component
export default class SmProgressCircular extends Vue {
  @Prop({ type: [String, Number], default: '40' })
  private readonly size!: string | number
}
</script>
